import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Module
import { MaterialModule } from './material/material.module';

// Standalone components
import { TablaReusableComponent } from './components/tabla-reusable/tabla-reusable.component';
import { FormGenericComponent } from './components/form-generic/form-generic.component';

// Pipes standalone
import { FilterPipe } from './pipes/filter.pipe';
import { FiltroPermisoPipe } from './pipes/filtroPermiso';

// Directivas standalone



import { TienePermisoDirective } from './directives/seguridad/tiene-permiso.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,


    // Standalone imports se pueden incluir aquí sin romper nada
    TablaReusableComponent,
    FormGenericComponent,
    TienePermisoDirective,
    FilterPipe,
    FiltroPermisoPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,


    // Standalone exports
    TablaReusableComponent,
    FormGenericComponent,
    TienePermisoDirective,
    FilterPipe,
    FiltroPermisoPipe
  ]
})
export class SharedModule { }
